import Vue from "vue";

Vue.filter('formatDateAu', function (value) {
    if (value == null) {
        return '';
    }
    var dateObj = new Date(Date.parse(value));
    var options = {year: 'numeric', month: 'numeric', day: 'numeric' };
    return dateObj.toLocaleDateString('en-AU', options);
});

Vue.filter('formatDateTimeAu', function (value) {
    if (value == null) {
        return '';
    }
    var dateObj = new Date(Date.parse(value));
    var options = {year: 'numeric', month: 'numeric', day: 'numeric', hour: "numeric", minute: "2-digit", second: "2-digit" , timeZoneName: "short"};
    return dateObj.toLocaleDateString('en-AU', options);
});



// WEBPACK FOOTER //
// ./resources/assets/js/filters/dates.js